import JoinCTA from '@/components/shared/JoinCTA';
import type React from 'react';
import { type HTMLAttributes, useContext, useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { CarPageContext } from './CarPageContext';

const CTA: React.FC<
  React.PropsWithChildren<
    HTMLAttributes<HTMLAnchorElement> & {
      customUrl?: string;
      glowing?: boolean;
      excludedParams?: string[];
    }
  >
> = ({ children = 'Check our prices', customUrl, glowing = true, excludedParams, ...props }) => {
  const { registerMainCta, setIsMainCtaVisible, analytics } = useContext(CarPageContext);
  const { ref, entry } = useInView();
  const [uuid] = useState<string>(String(Math.random()));

  useEffect(() => {
    registerMainCta(uuid, false);
  }, [registerMainCta, uuid]);

  useEffect(() => {
    if (!entry) return;

    setIsMainCtaVisible(uuid, entry?.isIntersecting);
  }, [entry, setIsMainCtaVisible, uuid]);

  return (
    <JoinCTA
      ref={ref}
      size="big"
      flavor="primary"
      id={analytics.ctaId}
      glowing={glowing}
      data-source={analytics.dataSource}
      product={analytics.product}
      minWidth={233}
      data-position="top"
      customUrl={customUrl}
      excludedParams={excludedParams}
      {...props}
    >
      {children}
    </JoinCTA>
  );
};

export default CTA;
